import { supabase } from '../supabase/config';

export const menuService = {
    fetchMenu: async (effectiveTenantId) => {
        if (!effectiveTenantId) return null;
        try {
            const { data, error } = await supabase
                .from('menus')
                .select('*')
                .eq('tenant_id', effectiveTenantId)
                .single();

            if (error || !data) return null;

            const ensureArrays = (obj) => {
                if (!obj || typeof obj !== 'object' || obj instanceof Date) return obj;
                const keys = Object.keys(obj);
                const isNumericMap = keys.length > 0 && keys.every(k => !isNaN(k));
                if (isNumericMap) return keys.sort((a, b) => parseInt(a) - parseInt(b)).map(k => ensureArrays(obj[k]));

                const cleaned = {};
                keys.forEach(k => { cleaned[k] = ensureArrays(obj[k]); });
                return cleaned;
            };

            let result = {
                tenantId: data.tenant_id,
                menuName: data.menu_name,
                description: data.description,
                categories: data.categories,
                categoriesJson: data.categories_json,
                designRecommendation: data.design_recommendation,
                updatedAt: data.updated_at,
            };

            if (result.categoriesJson) {
                try { result.categories = JSON.parse(result.categoriesJson); }
                catch (e) { result.categories = []; }
            }

            result = ensureArrays(result);
            if (!Array.isArray(result.categories)) result.categories = [];
            return result;
        } catch (error) {
            console.error("Fetch Menu Error:", error);
            throw error;
        }
    },

    saveMenu: async (effectiveTenantId, menuToSave) => {
        const menuData = JSON.parse(JSON.stringify(menuToSave)); // Deep clone

        const dbData = {
            tenant_id: effectiveTenantId,
            menu_name: menuData.menuName || '',
            description: menuData.description || '',
            design_recommendation: menuData.designRecommendation || {},
            categories_json: JSON.stringify(menuData.categories || []),
            updated_at: new Date().toISOString(),
        };

        const { error } = await supabase
            .from('menus')
            .upsert(dbData, { onConflict: 'tenant_id' });
        if (error) throw error;
    },

    uploadFile: async (effectiveTenantId, file) => {
        const filePath = `${effectiveTenantId}/${Date.now()}_${file.name}`;
        const { error: uploadError } = await supabase.storage
            .from('menus')
            .upload(filePath, file);
        if (uploadError) throw uploadError;

        const { data } = supabase.storage
            .from('menus')
            .getPublicUrl(filePath);
        return data.publicUrl;
    },

    uploadBase64: async (effectiveTenantId, base64String) => {
        const base64Content = base64String.split(',')[1];
        const byteCharacters = atob(base64Content);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'image/jpeg' });

        const fileName = `ai_gen_${Date.now()}.jpg`;
        const filePath = `${effectiveTenantId}/${fileName}`;

        const { error: uploadError } = await supabase.storage
            .from('menus')
            .upload(filePath, blob, { contentType: 'image/jpeg' });
        if (uploadError) throw uploadError;

        const { data } = supabase.storage
            .from('menus')
            .getPublicUrl(filePath);
        return data.publicUrl;
    }
};
